import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DataUploadsTab } from "@/components/admin/DataUploadsTab";
import { LatestUploadsTab } from "@/components/admin/LatestUploadsTab";
import { UploadLogsTab } from "@/components/admin/UploadLogsTab";
import type { UploadReport, UploadSource } from "@/lib/uploadConstants";


const DataUploadsPage = () => {
  const [tab, setTab] = useState("upload");
  const [latestFocus, setLatestFocus] = useState<{
    source: UploadSource;
    report: UploadReport;
    token: number;
  } | null>(null);

  const handleOpenLatest = (source: UploadSource, report: UploadReport) => {
    setLatestFocus({ source, report, token: Date.now() });
    setTab("latest");
  };

  return (
    <Tabs value={tab} onValueChange={setTab}>
      <TabsList className="mb-4">
        <TabsTrigger value="upload">Upload</TabsTrigger>
        <TabsTrigger value="logs">Logs</TabsTrigger>
        <TabsTrigger value="latest">Latest uploads</TabsTrigger>
      </TabsList>

      <TabsContent value="upload" className="focus-visible:outline-none">
        <DataUploadsTab onOpenLatest={handleOpenLatest} />
      </TabsContent>

      <TabsContent value="logs" className="focus-visible:outline-none">
        <UploadLogsTab />
      </TabsContent>

      <TabsContent value="latest" className="focus-visible:outline-none">
        <LatestUploadsTab focus={latestFocus} />
      </TabsContent>
    </Tabs>
  );
};

export default DataUploadsPage;
